$(document).ready(function() {
    if ($(window).width() <= 767) {
      // Move element 'text-content' before 'logo-img'
      $(".text-content").insertBefore(".logo-img");
    }
});